import script from "./play.vue?vue&type=script&setup=true&lang=js"
export * from "./play.vue?vue&type=script&setup=true&lang=js"

import "./play.vue?vue&type=style&index=0&id=f406953c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f406953c"]])

export default __exports__